import { digitalDataContainer } from "@/shared/FunctionCore";

export const setDigitalData = ({
  gcpPageName = "",
  companyName = "",
  pageTitle = "",
}): void => {
  const pages = {
    businessDirectoryPage: {
      contentID: "/content/dnb-us/en/home/business-directory",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Business Directory",
      pageTitle: "Business Directory",
      segment: "",
    },
    industryAnalysisPage: {
      companyName: "",
      contentID: "/content/dnb-us/en/home/business-directory/industry-analysis",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: `${pageTitle} - Industry Facts and Trends`,
      pageTitle: `${pageTitle} - Industry Facts and Trends`,
    },
    informationPage: {
      companyName: "",
      contentID:
        "/content/dnb-us/en/home/business-directory/company-information",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Company Information",
      pageTitle: "Company Information",
    },
    companyProfilePage: {
      companyName: `${companyName}, Ltd.`,
      contentID: "/content/dnb-us/en/home/business-directory/company-profiles",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Company Profiles",
      pageTitle: `${companyName}, Ltd. | Company Profile from Hoovers`,
    },
    startYourFreeTrial: {
      contentID:
        "/content/dnb-us/en/home/marketing/marketing-sales/hoovers-free-trial-directory",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Hoovers Free Trial - Directory",
      pageTitle: "Hoovers Free Trial - Directory",
      segment: "",
    },
    getAFreeTrial: {
      contentID:
        "/content/dnb-us/en/home/products/marketing-sales/dnb-hoovers/free-trial",
      contentType: "page",
      eloquaScoringTags: "cfo-purchase",
      event: "",
      pageName: "Try D&amp;B Hoovers for FREE",
      pageTitle: "Try D&amp;B Hoovers for FREE",
      segment: "",
    },
    contactDirectory: {
      contentID: "/content/dnb-us/en/home/contact-directory",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Contact Directory",
      pageTitle: "Contact Directory",
      segment: "",
    },
    contactDirectorySearch: {
      contentID:
        "/content/dnb-us/en/home/contact-directory/contact-industry-search",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Contact Industry Search",
      pageTitle: "Contact Industry Search",
      segment: "",
    },
    contactProfile: {
      contentID: "/content/dnb-us/en/home/contact-directory/contact-profile",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Contact Profile",
      pageTitle: "Contact Profile",
      segment: "",
    },
    companyProfile: {
      companyName: companyName,
      contentID: "/content/dnb-us/en/home/business-directory/company-profiles",
      contentType: "page",
      eloquaScoringTags: "",
      event: "",
      pageName: "Company Profiles",
      pageTitle: `${companyName} | Company Profile from Hoovers`
  }
  };

  let digitalData = {
    page: {
      clientContext: {
        DUNSNumber: "Unmatched Visitor",
        ITExpense: "Unmatched Visitor",
        SICCode: "Unmatched Visitor",
        annualSales: "Unmatched Visitor",
        companyAddress: "Unmatched Visitor",
        companyName: "Unmatched Visitor",
        companySize: "Unmatched Visitor",
        companyZip: "Unmatched Visitor",
        delinquencyRate: "Unmatched Visitor",
        domesticDUNSNumber: "Unmatched Visitor",
        employeeCount: "Unmatched Visitor",
        employeesAtAllLocation: "Unmatched Visitor",
        employeesAtLocation: "Unmatched Visitor",
        functionalArea: "Unmatched Visitor",
        howTheyPay: "Unmatched Visitor",
        industry: "Unmatched Visitor",
        jobFunction: "Unmatched Visitor",
        jobSeniority: "Unmatched Visitor",
        location: "Unmatched Visitor",
        marketability: "Unmatched Visitor",
        seniority: "Unmatched Visitor",
        ultimateDuns: "Unmatched Visitor",
        vanityTitle: "Unmatched Visitor",
        walletSize: "Unmatched Visitor",
      },
      pageInfo: { ...pages[gcpPageName] },
    },
  };

  if (gcpPageName === "startYourFreeTrial" || gcpPageName === "getAFreeTrial") {
    digitalData["page"]["cart"] = {
      productId: "Unmatched Visitor",
    };
  }

  // Expose globally
  window["digitalData"] = digitalData;

  digitalDataContainer.setDigitalData(digitalData);
};
